import React from 'react';

import style from './Transform.module.scss';

export default function TransformValue(props) {
  const { children, ...rest } = props;
  return (<span className={style.val} {...rest}>{children}</span>);
}
